import { displayMonthDay } from '../../../utils/displayMonthDay';

export const useNoticeDate = (date: string) => {
  return {
    displayDate: displayMonthDay(String(date)),
  };
};
